<mat-card-content class="product-list-card-container">
  <app-product-list #ProductList></app-product-list>
</mat-card-content>
